// src/helpers/notifications/tabs.ts

import { NotificationType, TabType } from './notificationConfig';

export const TABS: Record<TabType, { label: string; color: string }> = {
  all:      { label: 'All',      color: 'primary' },
  events:   { label: 'Events',   color: 'info'    },
  messages: { label: 'Messages', color: 'success' },
  updates:  { label: 'Updates',  color: 'warning' },
  news:     { label: 'News',     color: 'danger'  },
};
